<script lang="ts">
  import { Button } from "$lib/ui/button";

  import { DrawerFooter, DrawerHeader, DrawerTitle } from "$lib/ui/drawer";
  import { ArrowUpRight } from "lucide-svelte";

  interface Props {
    onAdminInvite: () => void;
    onAdminConnect: () => void;
    provider: {
      name: string;
      delegatedPermissions: { description: string; scopes: string[] }[];
      applicationPermissions: { description: string; scopes: string[] }[];
    };
  }

  let { onAdminInvite, onAdminConnect, provider }: Props = $props();
</script>

<DrawerHeader class="pt-8 px-6 pb-4">
  <DrawerTitle class="text-3xl text-left">Required scoped for {provider.name}</DrawerTitle>
</DrawerHeader>

<div class="my-5 gap-6 px-6 overflow-y-auto grow">
  <div class="">
    <div class="flex flex-col gap-3">
      <div class="border flex flex-col gap-2 divide-y-2">
        <div class="px-6 py-4">
          <h2 class="font-semibold text-xl">Delegated Permissions</h2>
          <p>These are used on behalf of users</p>
        </div>
        <div class="divide-y-2 p-6 flex flex-col space-y-3 *:py-3 first:*:pt-0 last:*:pb-0">
          {#each provider.delegatedPermissions as permission}
            <div class="space-y-2">
              <p>{permission.description}</p>
              <ul class="flex gap-2">
                {#each permission.scopes as scope}
                  <li
                    class="font-mono bg-[#F8FFC8] border border-[#F0FE98] px-1 py-0.5 rounded-md text-offblack text-sm"
                  >
                    {scope}
                  </li>
                {/each}
              </ul>
            </div>
          {/each}
        </div>
      </div>

      {#if provider.applicationPermissions.length > 0}
        <div class="border flex flex-col gap-2 divide-y-2">
          <div class="px-6 py-4">
            <h2 class="font-semibold text-xl">Application Permissions</h2>
            <p>These are used by Permissions Assurance directly</p>
          </div>
          <div class="divide-y-2 p-6 flex flex-col space-y-3 *:py-3 first:*:pt-0 last:*:pb-0">
            {#each provider.applicationPermissions as permission}
              <div class="space-y-2">
                <p>{permission.description}</p>
                <ul class="flex gap-2">
                  {#each permission.scopes as scope}
                    <li
                      class="font-mono bg-[#FFE2D4] border border-[#FFC1A8] px-1 py-0.5 rounded-md text-offblack text-sm"
                    >
                      {scope}
                    </li>
                  {/each}
                </ul>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>
<DrawerFooter class="px-6">
  <Button on:click={onAdminConnect}>
    <div class="flex items-center">
      <span>Connect as {provider.name} admin </span><ArrowUpRight />
    </div>
  </Button>
  <Button on:click={onAdminInvite}>
    Not a {provider.name} admin? Request access
  </Button>
</DrawerFooter>
